import { render, staticRenderFns } from "./DocHubResourceList.vue?vue&type=template&id=4f564abc"
import script from "./DocHubResourceList.vue?vue&type=script&lang=js"
export * from "./DocHubResourceList.vue?vue&type=script&lang=js"
import style0 from "./DocHubResourceList.vue?vue&type=style&index=0&id=4f564abc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports